import {NextApi} from "src/redux/service/Next/next";

export const GET_PACKAGES_LIST = 'GET_PACKAGES_LIST'

export const getPackageListNext = new NextApi('whitelabel/packages', GET_PACKAGES_LIST, {
  method: 'GET', json: false
});
